import { gql } from '@apollo/client';
import { apolloClient } from '../apollo/client';
import { Placar, SetPlacar } from '../types/placar';

export interface PlacarInput {
  partidaId?: string;
  sets: SetPlacar[];
  resultadoFinalA: number;
  resultadoFinalB: number;
}

export const LIMPAR_PLACAR = gql`
  mutation LimparPlacar($id: ID!) {
    limparPlacar(id: $id) {
      id
      resultadoFinalA
      resultadoFinalB
      sets {
        gamesA
        gamesB
        numeroSet
        tiebreakA
        tiebreakB
      }
    }
  }
`;

export interface LimparPlacarData {
  limparPlacar: Placar & { id: string };
}

export interface LimparPlacarVars {
  id: string;
}

export async function limparPlacar(id: string): Promise<Placar & { id: string }> {
  const { data } = await apolloClient.mutate<LimparPlacarData, LimparPlacarVars>({
    mutation: LIMPAR_PLACAR,
    variables: { id },
  });
  if (!data?.limparPlacar) {
    throw new Error('Erro ao limpar placar');
  }
  return data.limparPlacar;
}

export const CRIAR_PLACAR = gql`
  mutation CriarPlacar($input: PlacarInput!) {
    criarPlacar(input: $input) {
      id
      resultadoFinalA
      resultadoFinalB
      sets {
        gamesA
        gamesB
        numeroSet
        tiebreakA
        tiebreakB
      }
    }
  }
`;

export const ATUALIZAR_PLACAR = gql`
  mutation AtualizarPlacar($id: ID!, $input: PlacarInput!) {
    atualizarPlacar(id: $id, input: $input) {
      id
      resultadoFinalA
      resultadoFinalB
      sets {
        gamesA
        gamesB
        numeroSet
        tiebreakA
        tiebreakB
      }
    }
  }
`;

export interface CriarPlacarData {
  criarPlacar: Placar & { id: string };
}

export interface CriarPlacarVars {
  input: PlacarInput;
}

export interface AtualizarPlacarData {
  atualizarPlacar: Placar & { id: string };
}

export interface AtualizarPlacarVars {
  id: string;
  input: PlacarInput;
}

export async function criarPlacar(input: PlacarInput): Promise<Placar & { id: string }> {
  const { data } = await apolloClient.mutate<CriarPlacarData, CriarPlacarVars>({
    mutation: CRIAR_PLACAR,
    variables: { input },
  });
  if (!data?.criarPlacar) {
    throw new Error('Erro ao criar placar');
  }
  return data.criarPlacar;
}

export async function atualizarPlacar(id: string, input: PlacarInput): Promise<Placar & { id: string }> {
  const { data } = await apolloClient.mutate<AtualizarPlacarData, AtualizarPlacarVars>({
    mutation: ATUALIZAR_PLACAR,
    variables: { id, input },
  });
  if (!data?.atualizarPlacar) {
    throw new Error('Erro ao atualizar placar');
  }
  return data.atualizarPlacar;
}

